import _ from "lodash";
import {
  CURRICULUM_PROGRAM_TO_LEARNING_STANDARD_MAP,
  ACADEMIC_SETUP_TYPES,
} from "./stringConstants";
import { CURRICULUM_TYPE_PYP } from "Constants/stringConstants";
import { getIsAccountOrSchoolPortal } from "modules/CommonSelectors";

export const getCurrentUserDetailsFromState = state => {
  const {
    login: {
      userInfo: {
        id = "",
        first_name: firstName = "",
        middle_name: middleName = "",
        last_name: lastName = "",
        profile_image: profileImage = "",
      },
    } = {},
  } = state;

  return {
    id,
    firstName,
    middleName,
    lastName,
    profileImage,
  };
};

export const getCurriculumIdAndType = state => {
  const {
    id: currentCurriculumProgramId = "",
    nodeInterfaceType: currentCurriculumProgramType,
    type: curriculumProgramType,
  } = _.get(state, "platform.currentCurriculumProgram", {});

  const isPYPCurriculum = curriculumProgramType === CURRICULUM_TYPE_PYP;

  return {
    currentCurriculumProgramId,
    currentCurriculumProgramType,
    curriculumProgramType,
    isPYPCurriculum,
  };
};

export const getSetIdAndSetTypeFromState = state => {
  const {
    nodeInterfaceType: currentCurriculumProgramType,
    plannerElementSets,
  } = _.get(state, "platform.currentCurriculumProgram", {});

  const { currentPlannerElementSets = {} } = _.get(state, "platform", {});

  const plannerElementType =
    CURRICULUM_PROGRAM_TO_LEARNING_STANDARD_MAP?.[currentCurriculumProgramType];

  const currentPlannerElementSet =
    _.find(plannerElementSets, {
      type: plannerElementType,
    }) || currentPlannerElementSets?.[plannerElementType];
  const { id, type } = currentPlannerElementSet || {};

  return {
    setId: id,
    setType: type,
  };
};

export const getCurrentAcademicSetupTypeFromState = state => {
  const academicSetupType =
    _.get(state, "platform.currentCurriculumProgram.academicSetupType", null) ||
    ACADEMIC_SETUP_TYPES.OLD_SUBJECT_BASED_GRADING;

  const isSubjectBasedGrading =
    academicSetupType === ACADEMIC_SETUP_TYPES.SUBJECT_BASED_GRADING;
  const isCourseBasedGrading =
    academicSetupType === ACADEMIC_SETUP_TYPES.COURSE_BASED_GRADING;
  const isOldSubjectBasedGrading =
    academicSetupType === ACADEMIC_SETUP_TYPES.OLD_SUBJECT_BASED_GRADING;

  const isOldOrNewSubjectBasedGrading =
    isSubjectBasedGrading || isOldSubjectBasedGrading;

  return {
    academicSetupType,
    isSubjectBasedGrading,
    isCourseBasedGrading,
    isOldSubjectBasedGrading,
    isOldOrNewSubjectBasedGrading,
  };
};

export const getCurrentPlannerElementSetFromState = state => {
  const { nodeInterfaceType: curriculumInterfaceType } = _.get(
    state,
    "platform.currentCurriculumProgram",
    {}
  );

  const elementType =
    CURRICULUM_PROGRAM_TO_LEARNING_STANDARD_MAP[curriculumInterfaceType];

  const currentPlannerElementSets = _.get(
    state,
    "platform.currentPlannerElementSets",
    {}
  );

  const plannerElementSet = currentPlannerElementSets[elementType];

  return plannerElementSet;
};

export const getPrimaryAndChildCurriculumFromState = state => {
  const orgCurriculums = _.get(
    state,
    "platform.organizationCurriculumPrograms",
    []
  );
  const currentCurriculumProgram = _.get(
    state,
    "platform.currentCurriculumProgram",
    ""
  );

  const primaryCurriculum = _.find(
    orgCurriculums,
    curriculum =>
      curriculum.type === currentCurriculumProgram.type && curriculum.isPrimary
  );

  const childCurriculums = [];
  _.forEach(orgCurriculums, curriculum => {
    if (primaryCurriculum && primaryCurriculum.id !== curriculum.id)
      childCurriculums.push(curriculum.id);
  });

  const isPrimaryCurriculum =
    primaryCurriculum && primaryCurriculum.id === currentCurriculumProgram.id;

  const isChildCurriculum =
    primaryCurriculum && primaryCurriculum.id !== currentCurriculumProgram.id;

  return {
    isPrimaryCurriculum,
    isChildCurriculum,
    primaryCurriculumId: primaryCurriculum?.id,
    childCurriculums,
  };
};

export const getIsAdminPortal = state => {
  const loginActiveTab = _.get(state, "login.activeTab");
  const isAccountOrSchoolPortal = getIsAccountOrSchoolPortal(state);
  return loginActiveTab === "admin" || isAccountOrSchoolPortal;
};
